import React from 'react'
import { MdClose } from 'react-icons/md'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom'
import { Dialog } from '@reach/dialog'
import '@reach/dialog/styles.css'
import Xcontest from 'src/components/Xcontest/Xcontest'
import ContestOnBoarding from 'src/components/Xcontest/OnBoarding/ContestOnBoarding'
import CreateContest from 'src/components/Xcontest/createContest/CreateContest'
import About from 'src/components/Xcontest/About/About'
import Activity from 'src/components/Xcontest/Activity/Activity'
import LeaderBoard from 'src/components/Xcontest/LeaderBoard/LeaderBoard'
import './style.css'
import { CloseModalSvg } from 'src/assets'
import { getModalsPathId } from './ModalsPath'
import { getCustomModalsPathId } from './ModalsPath'
import { getCustomModalsCollaboPathId } from '../../Collabo/CollaboInvite'
import { getCustomModalsBankPathId } from 'src/components/HomePage/ModalsContent/BankSettings/BankDetailsRender'
import { DeleteBankCard } from 'src/components/HomePage/ModalsContent/Cards/DeleteCard'
import { getTargetModalsPathId } from './ModalsPath'
import BankDelete from 'src/components/HomePage/ModalsContent/BankSettings/BankDelete'
import { PlanInfo } from 'src/components/HomePage/ModalsContent/createPlans/PlanInfo'
import { AcceptCollabo } from 'src/components/HomePage/ModalsContent/TargetPlanModal/AcceptCollaboInvite'
import { CloseModal } from 'src/assets'
import { InvestInfo } from 'src/components/Investment/InvestmentInfo/InvestInfo'
import {
  getCustomInvestmentModalsPathId,
  getModalsPaymentPathId,
  getModalstargetPaymentPathId,
  getModalsHomepagePathId,
  getModalsHelpPathId,
  getModalsEarnPathId,
  getModalsContestPathId,
  getModalsXContestPathId,
  getJoinedContestPathId,
  getModalscontestPaymentPathId,
  getLogoutModalsPathId,
  getCustomCardModalsPathId,
} from './ModalsPath'
import { Homepage } from 'src/Pages/HomePage/Homepage'
import { GeneralSavingsPage } from 'src/Pages/GeneralSavings'
import { Settings } from 'src/Pages/Settings'
import { Investment } from 'src/Pages/Investment'
import { TargetSavings } from 'src/Pages/TargetSavings'
import JoinedContestDetail from 'src/components/Xcontest/MyContest/JoinedContest/JoinedContestDetail'
const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 36px;
    height: 36px;
    top: 20px;
  }
`
const HelpClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  color: white;
  z-index: 10;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 30px;
    height: 52px;
    top: 22px;
  }
`

const HelpModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsHelpPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Settings />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <div className="content-help">{image.title}</div>
          <div className="ClosedModalButton" onClick={onDismiss}>
            <HelpClosedModalButton aria-label="Close modal" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const ContestJoinedModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getJoinedContestPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <JoinedContestDetail />
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const JoinedAboutModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getJoinedContestPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <About />
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const JoinedActivityModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getJoinedContestPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <Activity />
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const JoinedLeaderboardModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getJoinedContestPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <LeaderBoard />
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const ContestPaymentModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsXContestPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <div className="content-help">{image.title}</div>

          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const ContestDetailModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsContestPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <CreateContest />

          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const ContestModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsContestPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <ContestOnBoarding />
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const EarnModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsEarnPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Settings />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <div className="contentss-earn">{image.title}</div>
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const Modal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Settings />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <div className="contentss">{image.title}</div>
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const PlansModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <Dialog
      aria-labelledby="label"
      onDismiss={onDismiss}
      initialFocusRef={buttonRef}
    >
      <div className="modalWrapper">
        <div className="contentss">{image.title}</div>

        <div className="ClosedModalButton" onClick={onDismiss}>
          <img src={CloseModal} alt="Close" />
        </div>
      </div>
    </Dialog>
  )
}
const CustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getLogoutModalsPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Settings />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapperbig">
          <div className="width">{image.title}</div>
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const PlanCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getCustomModalsPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div>
      <GeneralSavingsPage />
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper color">
          <div className="contentss">
            <PlanInfo />
          </div>
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const PaymentPlanCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsPaymentPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div>
      <GeneralSavingsPage />
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper color">
          <div className="contentss">{image.title}</div>{' '}
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const PaymentHomePageCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalsHomepagePathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div>
      <Homepage />
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper color">
          <div className="contentss">{image.title}</div>{' '}
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const ContestXPaymentModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalscontestPaymentPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Xcontest />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <div className="contentss">{image.title}</div>{' '}
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const PaymentPlanTargetCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getModalstargetPaymentPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div>
      <TargetSavings />
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper color">
          <div className="contentss">{image.title}</div>{' '}
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const PlanTargetCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getTargetModalsPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div>
      <TargetSavings />
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper color">
          <div className="contentss">
            <PlanInfo />
          </div>
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const InvestmentCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getCustomInvestmentModalsPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div>
      <Investment />
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper color">
          <div className="contentss">
            <InvestInfo />
          </div>
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

const CollaboCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getCustomModalsCollaboPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <Dialog
      aria-labelledby="label"
      onDismiss={onDismiss}
      initialFocusRef={buttonRef}
    >
      <div className="modalWrapper pad">
        <AcceptCollabo />
        {/* <div className="contentss">{image.title}</div> */}
        <div className="ClosedModalButton" onClick={onDismiss}>
          <img src={CloseModal} alt="Close" />
        </div>
      </div>
    </Dialog>
  )
}

const BankCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getCustomModalsBankPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Settings />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <BankDelete />
          <div className="ClosedModalButton" onClick={onDismiss}>
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
const CardCustomModal = () => {
  let navigate = useNavigate()
  let { id } = useParams<'id'>()
  let image = getCustomCardModalsPathId(id)
  let buttonRef = React.useRef<HTMLButtonElement>(null)

  function onDismiss() {
    navigate(-1)
  }
  if (!image) return null
  return (
    <div className="head">
      <div className="pointer">
        <Settings />
      </div>
      <Dialog
        aria-labelledby="label"
        onDismiss={onDismiss}
        initialFocusRef={buttonRef}
      >
        <div className="modalWrapper">
          <DeleteBankCard />
          <div className="ClosedModalButton" onClick={onDismiss}>
            {/* <HelpClosedModalButton aria-label="Close modal" /> */}
            <img src={CloseModal} alt="Close" />
          </div>
        </div>
      </Dialog>
    </div>
  )
}
export {
  Modal,
  CustomModal,
  PlansModal,
  PlanCustomModal,
  CollaboCustomModal,
  BankCustomModal,
  CardCustomModal,
  InvestmentCustomModal,
  PlanTargetCustomModal,
  PaymentPlanCustomModal,
  PaymentPlanTargetCustomModal,
  PaymentHomePageCustomModal,
  HelpModal,
  EarnModal,
  ContestModal,
  ContestDetailModal,
  ContestPaymentModal,
  ContestJoinedModal,
  JoinedLeaderboardModal,
  JoinedActivityModal,
  JoinedAboutModal,
  ContestXPaymentModal,
}
